'use client';

import { Image } from '@bw/elements';
import { PlayButton } from '@bw/elements/icons';
import { useState } from 'react';
import styles from './VideoListing.module.scss';

interface VideoListingItemProps {
	video: {
		agencyName?: string;
		location?: string;
		name?: string;
		url?: string;
	};
	thumbnailUrl: string | null;
}

export function VideoListingItem({ video, thumbnailUrl }: VideoListingItemProps) {
	const [videoIsVisible, setVideoIsVisible] = useState(false);

	const handleImageClick = () => {
		setVideoIsVisible(true);
	};

	return (
		<li data-aos="fade-up">
			<div className={styles['leaders']}>
				<figure
					className="aspect-box is__video"
					style={
						{ '--aspect-ratio': '225/400' } as React.CSSProperties
					}
				>
					<div
						onClick={handleImageClick}
						style={{
							display: videoIsVisible ? 'none' : 'block',
						}}
						className="image_logo_wrapper"
						tabIndex={0}
						onKeyDown={(e) => {
							// Handle Enter key press
							if (e.key === 'Enter') {
								handleImageClick();
							}
						}}
					>
						<div
							style={{
								transition: 'opacity 0.5s ease-in-out',
							}}
						>
							<span className="play__icon">
								<button className="play_button" aria-label="Play">
									<PlayButton width={55} height={55} />
								</button>
							</span>
							<Image
								className="poster__img"
								src={thumbnailUrl ?? ''}
								alt="youtube thumbnail"
								width={450}
								height={450}
							/>
						</div>
					</div>
					{videoIsVisible && (
						<iframe
							width="560"
							height="315"
							src={`${video.url}&autoplay=1`}
							title="YouTube video player"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					)}
				</figure>

				<article>
					<h2 data-aos="fade-up">{video.agencyName}</h2>
					<p data-aos="fade-up">{video.location}</p>
				</article>
			</div>
		</li>
	);
}
